import { api } from "./api";

export const GET_ALL_CARS = async () => {
    const { data } = await api.get("/cars")
    return data.cars || [];
}

export const GET_CAR = async (id: string) => {
    const { data } = await api.get(`/cars/${id}`)
    return data;
}

export const DELETE_CAR = async (id: string) => {
    const { data } = await api.delete(`/cars/${id}`)
    return data;
}

export const CREATE_CAR = async (params: any) => {
    const { data } = await api.post(`/cars`, params)
    return data;
}

export const UPDATE_CAR = async (id: string, params: any) => {
    const { data } = await api.patch(`/cars/${id}`, params)
    return data;
}

